var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"errorBox"},[_c('h1',[_vm._v("Something went wrong. Please try logging again.")]),_c('p',[_vm._v("\n    Please\n    "),_c('a',{attrs:{"href":_vm.url}},[_vm._v("click")]),_vm._v(" to redirect to login screen.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }